const CRUD_TYPES = {
  Insert: 1,
  Edit: 2
};

export { CRUD_TYPES };
